import { http } from 'utils'

// Talent profile state.
const state = {}

// Talent profile state getters.
const getters = {}

// Talent profile actions.
const actions = {

  /**
   * Get a booking PDF.
   * The audience and userId are for when an admin is retrieving pdf acting as the audience.
   *
   * @return Promise
   */
  getCustomPdf (store, { id, startDate, endDate, template }) {
    let params = {
      start_date: startDate,
      end_date: endDate,
      template
    }
    return http.get(`nrl/${id}/custom/pdf`, { params })
  },

  /**
   * Get a talent's marketing photos from backend
   *
   * @return Promise
   */
  getTalentMarketingPhotos ({ commit }, id) {
    return http.get(`users/${id}/talent_marketing_photo`)
      .then((response) => {
        let photos = []

        for (let i = 0; i < response.data.length; i++) {
          photos.push(response.data[i])
        }
        return photos
      })
  },

  getTalentPackages ({ commit }, id) {
    return http.get(`users/${id}/packages`)
      .then((response) => {
        return response
      })
  },

  updateTalentPackages ({ commit }, { id, payload }) {
    return http.post(`users/${id}/packages`, payload)
      .then((response) => {
        return response
      })
  },

  /**
   * Upload a talents profile image.
   *
   * @return Promise
   */
  uploadTalentProfileImage ({ commit }, { id, file, cropPayload }) {
    let payload = new FormData()

    payload.append('profile_image', file)
    payload.append('profile_image_crop[x]', cropPayload.x)
    payload.append('profile_image_crop[y]', cropPayload.y)
    payload.append('profile_image_crop[width]', cropPayload.width)
    payload.append('profile_image_crop[height]', cropPayload.height)
    payload.append('profile_image_crop[scaleX]', cropPayload.scaleX)
    payload.append('profile_image_crop[scaleY]', cropPayload.scaleY)

    return http.post(`users/${id}/talent_profile_image`, payload)
  },

  /**
   * Delete a talent's marketing photo
   *
   * @return Promise
   */
  deleteTalentMarketingPhoto ({ commit, state }, { id, photoUrl }) {
    let payload = new FormData()

    payload.append('photoUrl', photoUrl)

    return http.delete(`users/${id}/talent_marketing_photo`, { data: { photoUrl: photoUrl } })
  },

  /**
   * Add a talent's marketing photo
   *
   * @return Promise
   */
  addMarketingPhoto ({ commit }, {id, photoUrl, file}) {
    let payload = new FormData()

    payload.append('newPhotoFile', file)

    return http.post(`users/${id}/talent_marketing_photo`, payload)
  }
}

// Talent profile state mutations.
const mutations = {}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
